import { useState } from "react";

import { Stack, StackItem, useTheme } from "@bps/fluent-ui";
import { UseFormMethods } from "@bps/form-api/dist/src/lib/form-api.types";
import { SectionTitle } from "@components/SectionTitle";
import {
  DeviceAdvancedSearchArgs,
  DeviceDetail
} from "@libs/api/gateways/field/field-ops-gateway.dtos";

import { SelectorFormValues } from "../selectors/edit/formUtils";
import { DeviceSearchColumnSelect } from "./DeviceSearchColumnSelect";
import { DeviceSearchForm } from "./DeviceSearchForm";
import { DeviceSearchResults } from "./results/DeviceSearchResults";

interface DeviceSearchHostProps {}

export const DeviceSearchScreen: React.FC<DeviceSearchHostProps> = ({}) => {
  const theme = useTheme();

  const [args, setArgs] = useState<DeviceAdvancedSearchArgs>({ rules: [] });
  const [submitted, setSubmitted] = useState(false);
  const [selectedDevices, setSelectedDevices] = useState<DeviceDetail[]>([]);
  const [customColumns, setCustomColumns] = useState<string[]>([]);

  const onSubmit = async (
    values: SelectorFormValues,
    actions: Pick<UseFormMethods<SelectorFormValues>, "reset" | "setValue">
  ) => {
    setSubmitted(true);
    setArgs(values);
    setSubmitted(false);
    actions.reset(values);
  };

  return (
    <Stack
      verticalFill
      styles={{
        root: { padding: theme.spacing.s1, width: "100%" }
      }}
      tokens={{ childrenGap: theme.spacing.m }}
    >
      <SectionTitle>Device Search</SectionTitle>

      <Stack verticalFill>
        <StackItem
          styles={{
            root: {
              overflowY: "auto",
              minHeight: 171,
              maxHeight: 400
            }
          }}
        >
          <Stack
            horizontal
            tokens={{ childrenGap: theme.spacing.m }}
            styles={{
              root: {
                width: "100%"
              }
            }}
          >
            <DeviceSearchForm
              onSubmit={onSubmit}
              isLoading={submitted}
              selectedDevices={selectedDevices}
            />
            <DeviceSearchColumnSelect
              customColumns={customColumns}
              setCustomColumns={setCustomColumns}
            />
          </Stack>
        </StackItem>

        <DeviceSearchResults
          customColumns={customColumns}
          args={args}
          setSelectedDevices={setSelectedDevices}
        />
      </Stack>
    </Stack>
  );
};
